import { useNavigate } from 'react-router-dom';
import Navbar from '../../components/Navbar/Navbar';
import './AdminDashboard.css';

/* ── Icons ──────────────────────────────────────── */
function IconNotifications() {
  return (
    <svg width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9" />
      <path d="M13.73 21a2 2 0 0 1-3.46 0" />
      <line x1="12" y1="2" x2="12" y2="4" />
    </svg>
  );
}

function IconUsers() {
  return (
    <svg width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
      <circle cx="9" cy="7" r="4" />
      <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
      <path d="M16 3.13a4 4 0 0 1 0 7.75" />
    </svg>
  );
}

function IconLogs() {
  return (
    <svg width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
      <polyline points="14 2 14 8 20 8" />
      <line x1="16" y1="13" x2="8" y2="13" />
      <line x1="16" y1="17" x2="8" y2="17" />
      <line x1="10" y1="9" x2="8" y2="9" />
    </svg>
  );
}

function IconCalendarLock() {
  return (
    <svg width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <path d="M21 11V6a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h6" />
      <line x1="16" y1="2" x2="16" y2="6" />
      <line x1="8" y1="2" x2="8" y2="6" />
      <line x1="3" y1="10" x2="21" y2="10" />
      <rect x="14" y="15" width="8" height="6" rx="1" />
      <path d="M16 15v-1.5a2 2 0 0 1 4 0V15" />
    </svg>
  );
}

/* ── Card definitions ───────────────────────────── */
const ADMIN_CARDS = [
  {
    key: 'notificaciones',
    label: 'Notificaciones Globales',
    icon: <IconNotifications />,
    path: '/admin-notifications',
  },
  {
    key: 'usuarios',
    label: 'Administración de Usuarios',
    icon: <IconUsers />,
    path: '/admin-users',
  },
  {
    key: 'registros',
    label: 'Registros de Comportamiento',
    icon: <IconLogs />,
    path: '/admin-logs',
  },
  {
    key: 'permisos-bitacora',
    label: 'Permisos de Bitácora',
    icon: <IconCalendarLock />,
    path: '/admin-timelog-permissions',
  },
];

/* ── Component ──────────────────────────────────── */
function AdminDashboard() {
  const navigate = useNavigate();

  return (
    <div className="adm-page">
      <Navbar />

      <main className="adm-main">
        <section className="adm-welcome">
          <h1 className="adm-heading">Tablero de Administración</h1>
          <p className="adm-sub">Estas son las herramientas de administración del portal</p>
        </section>

        <section className="adm-cards">
          {ADMIN_CARDS.map((card, index) => (
            <button
              key={card.key}
              className="adm-card"
              style={{ '--delay': `${index * 70}ms` }}
              onClick={() => card.path && navigate(card.path)}
            >
              <span className="adm-card-icon">{card.icon}</span>
              <span className="adm-card-label">{card.label}</span>
            </button>
          ))}
        </section>
      </main>

      <footer className="adm-footer">
        Created by: Fernando Núñez for WSP International / Ver 0.1
      </footer>
    </div>
  );
}

export default AdminDashboard;
